<template>
  <v-row class="mt-12 mx-6">
    <v-tooltip left>
      <template #activator="{ on, attrs }">
        <v-btn
          v-on="on"
          v-bind="attrs"
          fixed
          fab
          bottom
          right
          color="blue darken-2"
          style="bottom:74px;width:50px;height:50px"
          @click="prevDataSheet = true"
        >
          <v-icon color="white"> mdi-card-account-details-outline </v-icon>
        </v-btn>
      </template>
      <span>Previsualizar Ficha tecnica</span>
    </v-tooltip>

    <v-tooltip left>
      <template #activator="{ on, attrs }">
        <v-btn
          v-on="on"
          v-bind="attrs"
          fixed
          fab
          bottom
          right
          color="amber darken-2"
          style="bottom:16px;width:50px;height:50px"
          @click="prevCredential = true"
        >
          <v-icon color="white"> mdi-qrcode-scan </v-icon>
        </v-btn>
      </template>
      <span>Previsualizar Credencial Virtual</span>
    </v-tooltip>

    <v-tooltip
      v-if="showFloatingAdd && user.permissions.Membership && user.permissions.Membership.update == true"
      left
    >
      <template #activator="{ on, attrs }">
        <v-btn
          v-on="on"
          v-bind="attrs"
          fixed
          fab
          bottom
          right
          color="accent"
          style="bottom:132px;width:50px;height:50px"
          @click="addField"
        >
          <v-icon color="white">mdi-plus</v-icon>
        </v-btn>
      </template>
      <span>Nuevo campo</span>
    </v-tooltip>

    <v-tooltip v-if="showFloatingAdd" left>
      <template #activator="{ on, attrs }">
        <v-btn
          v-on="on"
          v-bind="attrs"
          fixed
          fab
          bottom
          right
          color="primary"
          style="bottom:190px;width:50px;height:50px"
          @click="scrollToTop"
        >
          <v-icon color="white">mdi-arrow-up</v-icon>
        </v-btn>
      </template>
      <span>Ir al inicio</span>
    </v-tooltip>

    <v-col cols="12">
      <v-row align="center">
        <v-col cols="8">
          <p class="headline font-weight-bold mb-0">
            Configuración del formulario de registro
          </p>
        </v-col>
        <v-col cols="4" class="d-flex justify-end align-center">
          <v-tooltip bottom>
            <template #activator="{ on, attrs }">
              <v-btn icon v-on="on" v-bind="attrs" @click="showTutorial = true">
                <v-icon color="grey darken-1">mdi-help-circle-outline</v-icon>
              </v-btn>
            </template>
            <span>Ver tutorial de secciones</span>
          </v-tooltip>
          <template v-if="user.permissions.Membership && user.permissions.Membership.update == true">
            <action-button
              class="mr-2"
              outlined
              @click="addSection"
              iconLeft
              icon="mdi-table-row-plus-after"
            >
              Agregar sección
            </action-button>
            <action-button @click="addField" iconLeft icon="mdi-plus">
              Nuevo campo
            </action-button>
          </template>
        </v-col>
      </v-row>
      <v-row class="mt-0 mb-1">
        <v-col cols="12" class="pt-1">
          <FixedFieldsNotice mode="memberships" :showPosition="allowSubmembers" />
        </v-col>
      </v-row>

      <v-divider class="mb-6" />

      <!-- Tabs por sección + botón filtros -->
      <div class="d-flex align-center mb-1">
        <v-tabs v-model="activeTab" background-color="transparent" show-arrows style="flex:1">
          <v-tab v-for="tab in tabList" :key="tab._id || 'unsectioned'">
            {{ tab.name }}
          </v-tab>
        </v-tabs>
        <v-tooltip bottom>
          <template #activator="{ on, attrs }">
            <v-btn
              v-on="on"
              v-bind="attrs"
              small
              :color="visibilityFilter !== 'ALL' ? 'primary' : 'grey lighten-2'"
              :dark="visibilityFilter !== 'ALL'"
              rounded
              depressed
              class="ml-2 flex-shrink-0"
              @click="showAdvancedFilters = !showAdvancedFilters"
              style="min-width:0; padding: 0 12px"
            >
              <v-badge
                :value="visibilityFilter !== 'ALL'"
                dot
                color="white"
                overlap
                offset-x="6"
                offset-y="6"
              >
                <v-icon small>mdi-filter-variant</v-icon>
              </v-badge>
            </v-btn>
          </template>
          <span>{{ showAdvancedFilters ? 'Ocultar filtros' : 'Filtros avanzados' }}</span>
        </v-tooltip>
      </div>

      <!-- Panel Filtros Avanzados -->
      <v-expand-transition>
        <v-row v-if="showAdvancedFilters" class="mt-1 mb-2 px-1" no-gutters align="center">
          <v-col cols="12">
            <v-divider class="mb-3" />
            <p class="caption grey--text text--darken-1 mb-2 font-weight-medium">FILTRAR POR VISIBILIDAD</p>
            <v-btn-toggle v-model="visibilityFilter" rounded dense mandatory>
              <v-btn small value="ALL">Todos</v-btn>
              <v-btn small value="MEMBER">
                <v-icon left x-small>mdi-account</v-icon>
                Solo Miembros
              </v-btn>
              <v-btn small value="MEMBERSHIP_USER">
                <v-icon left x-small>mdi-account-multiple</v-icon>
                Solo Submiembros
              </v-btn>
            </v-btn-toggle>
          </v-col>
        </v-row>
      </v-expand-transition>

      <v-divider class="mb-4" />
      <v-tabs-items v-model="activeTab">
        <v-tab-item v-for="tab in tabList" :key="tab._id || 'unsectioned'">

          <!-- Renombrar / eliminar sección (solo secciones reales) -->
          <v-row
            v-if="tab._id && user.permissions.Membership && user.permissions.Membership.update == true"
            align="center"
            class="mt-3 mb-4 px-1"
            no-gutters
          >
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                v-model="tab.name"
                label="Nombre de la sección"
                dense
                filled
                rounded
                hide-details
                @focus="tab._editing = true"
              />
            </v-col>
            <v-col cols="auto" class="ml-2">
              <v-btn
                icon
                small
                color="green"
                :loading="savingSectionId === tab._id"
                v-if="tab._editing"
                @click="saveSectionName(tab)"
              >
                <v-icon small>mdi-content-save-outline</v-icon>
              </v-btn>
              <v-btn icon small color="red" @click="removeSectionAdmin(tab)">
                <v-icon small>mdi-trash-can-outline</v-icon>
              </v-btn>
            </v-col>
          </v-row>

          <v-row justify="center" class="mt-2">
            <v-col v-if="fieldsForTab(tab._id).length === 0" cols="12" class="pt-4 text-center">
              <v-icon color="grey lighten-1" size="40">mdi-filter-off-outline</v-icon>
              <p class="grey--text mt-2">No hay campos con esta configuración de visibilidad.</p>
            </v-col>
            <v-col v-if="fieldsForTab(tab._id).length > 0" cols="12" class="pt-0">
              <draggable
                :list="fieldsForTab(tab._id)"
                handle=".drag-handle"
                :animation="200"
                ghost-class="drag-ghost"
                @end="e => onFieldDragEnd(e, tab._id)"
              >
              <v-card
                v-for="field in fieldsForTab(tab._id)"
                :key="field._id"
                outlined
                rounded="lg"
                class="mb-3"
              >
                <!-- HEADER: siempre visible -->
                <v-list-item style="cursor:pointer" @click="toggleField(field)">
                  <v-icon
                    class="drag-handle mr-3"
                    color="grey lighten-1"
                    @click.stop
                  >mdi-drag-vertical</v-icon>
                  <v-list-item-content>
                    <v-list-item-title class="font-weight-medium">
                      {{ field.name || 'Nuevo campo' }}
                    </v-list-item-title>
                    <v-list-item-subtitle v-if="!isFieldOpen(field)" class="d-flex align-center flex-wrap" style="gap:4px">
                      {{ fieldTypeLabel(field.fieldType) }}
                      <v-chip v-if="field.required" x-small color="red lighten-4" text-color="red darken-2" class="ml-1">Requerido</v-chip>
                      <v-chip v-if="hasChapters && field.visibleFor && field.visibleFor.includes('BRANCH')" x-small color="purple lighten-4" text-color="purple darken-2" class="ml-1">Cap. Locales</v-chip>
                      <v-chip v-if="field.visibleFor && field.visibleFor.includes('MEMBER')" x-small color="blue lighten-4" text-color="blue darken-2" class="ml-1">Miembro Titular</v-chip>
                      <v-chip v-if="field.visibleFor && field.visibleFor.includes('MEMBERSHIP_USER')" x-small color="teal lighten-4" text-color="teal darken-2" class="ml-1">Submiembros</v-chip>
                      <v-chip v-if="!field.visibleFor || field.visibleFor.length === 0" x-small color="orange lighten-4" text-color="orange darken-3" class="ml-1">Sin visibilidad</v-chip>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                  <!-- Botones de acción -->
                  <v-dialog
                    v-if="!field.new && !field.edit"
                    v-model="field.deleteDialog"
                    width="300"
                    @click.native.stop
                  >
                    <template #activator="{ on, attrs }">
                      <v-btn
                        icon
                        x-small
                        color="red lighten-2"
                        v-on="on"
                        v-bind="attrs"
                        @click.stop
                        :disabled="!user.permissions.Membership || !user.permissions.Membership.update"
                      >
                        <v-icon small>mdi-trash-can-outline</v-icon>
                      </v-btn>
                    </template>
                    <v-card>
                      <v-card-title class="text-h5">Eliminar campo extra</v-card-title>
                      <v-divider />
                      <v-card-text class="text-justify my-5">
                        {{
                          field.new
                            ? "¿Seguro que no quiere guardar este campo?"
                            : `¿Seguro de que quiere eliminar el campo "${field.name}"?`
                        }}
                      </v-card-text>
                      <v-divider />
                      <v-card-actions>
                        <v-spacer />
                        <v-btn color="grey" text @click="field.deleteDialog = false" :disabled="!user.permissions.Membership || !user.permissions.Membership.update">Cancelar</v-btn>
                        <v-btn color="red" text @click="deleteField(field)" :disabled="!user.permissions.Membership || !user.permissions.Membership.update">Eliminar</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                  <icon-action-button
                    v-if="field.new || field.edit"
                    tooltip="Cancelar"
                    color="red"
                    @click.native.stop
                    @click="cancelAction(field)"
                    :disabled="!user.permissions.Membership || !user.permissions.Membership.update"
                  >mdi-close</icon-action-button>
                  <icon-action-button
                    v-if="field.new || field.edit"
                    :tooltip="(field.new && 'Guardar') || (field.edit && 'Actualizar')"
                    color="green"
                    @click.native.stop
                    @click="saveField(field)"
                    :disabled="!isFieldValid || !user.permissions.Membership || !user.permissions.Membership.update || disableField(field)"
                  >mdi-content-save-outline</icon-action-button>
                  <v-icon class="ml-1">{{ isFieldOpen(field) ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                </v-list-item>

                <!-- CONTENIDO colapsable -->
                <v-expand-transition>
                  <div v-show="isFieldOpen(field)">
                    <v-divider />
                    <div v-if="!field.new && !field.edit" class="d-flex justify-end px-3 pt-2">
                      <icon-action-button
                        tooltip="Editar"
                        color="accent"
                        @click="editField(field)"
                        :disabled="!user.permissions.Membership || !user.permissions.Membership.update"
                      >mdi-pencil-outline</icon-action-button>
                    </div>
                    <v-row class="pa-3 ma-0" justify="center">
                      <v-col cols="12" sm="6" md="4" lg="3">
              <p class="font-weight-bold">Tipo de campo</p>
              <v-radio-group
                :mandatory="false"
                v-model="field.fieldType"
                class="ml-2"
                :disabled="!field.edit && !field.new"
              >
                <v-radio
                  color="primary"
                  label="Campo de texto"
                  value="TEXT"
                ></v-radio>
                <v-radio
                  color="primary"
                  label="Opción múltiple"
                  value="LIST"
                ></v-radio>
                <v-radio
                  color="primary"
                  label="Documento"
                  value="DOC"
                ></v-radio>
                <v-radio color="primary" label="Fecha" value="DATE"></v-radio>
                <v-radio
                  color="primary"
                  label="Número"
                  value="NUMBER"
                ></v-radio>

                <template v-if="false">
                  <p class="font-weight-medium">Avanzadas</p>
                  <v-radio
                    color="primary"
                    label="Lista de países"
                    value="COUNTRY"
                  ></v-radio>
                </template>
              </v-radio-group>
              <p class="font-weight-bold">Opciones</p>
              <v-switch
                v-model="field.required"
                class="ml-2"
                color="primary"
                label="¿Obligatorio?"
                hide-details="auto"
                :disabled="!field.edit && !field.new"
              ></v-switch>
              <v-switch
                v-model="field.showInCredential"
                class="ml-2"
                color="primary"
                label="Mostrar en la credencial virtual"
                hide-details="auto"
                :disabled="!field.edit && !field.new"
              ></v-switch>
              <v-switch
                v-model="field.showInDataSheet"
                class="ml-2"
                color="primary"
                label="Mostrar en la ficha técnica"
                hide-details="auto"
                :disabled="!field.edit && !field.new"
              ></v-switch>
            </v-col>

            <v-col cols="12" sm="6" md="3" lg="4">
              <p class="font-weight-bold">Configuración</p>
              <v-text-field
                label="Nombre del campo o pregunta"
                v-model="field.name"
                filled
                rounded
                :disabled="!field.edit && !field.new"
              ></v-text-field>
              <v-text-field
                label="Descripción"
                v-model="field.description"
                filled
                rounded
                :disabled="!field.edit && !field.new"
              ></v-text-field>
              <v-select
                v-if="formSections.length > 0"
                v-model="field.section"
                :items="[{ _id: null, name: 'Sin sección' }, ...formSections]"
                item-text="name"
                item-value="_id"
                label="Sección"
                filled
                rounded
                clearable
                :disabled="!field.edit && !field.new"
              />

              <v-combobox
                v-model="field.options"
                v-if="field.fieldType === 'LIST' && !field._isDependent"
                hide-selected
                hint="Agrega las opciones de tu campo."
                label="Opciones del campo"
                multiple
                persistent-hint
                small-chips
                filled
                rounded
                :disabled="!field.edit && !field.new"
              >
                <template v-slot:no-data>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title>
                        Presiona
                        <kbd>enter</kbd> para crear una nueva opción.
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </template>
              </v-combobox>

              <!-- Allow multiple answers toggle -->
              <v-switch
                v-if="field.fieldType === 'LIST'"
                v-model="field.allowMultiple"
                class="ml-2 mt-2"
                color="primary"
                label="Permitir seleccionar múltiples respuestas"
                hide-details="auto"
                :disabled="!field.edit && !field.new"
              />

              <!-- Dependent LIST configuration -->
              <v-switch
                v-if="field.fieldType === 'LIST'"
                v-model="field._isDependent"
                class="ml-2 mt-2"
                color="primary"
                label="¿Dependiente de otro campo?"
                hide-details="auto"
                :disabled="!field.edit && !field.new"
                @change="onToggleDependent(field)"
              />
              <template v-if="field.fieldType === 'LIST' && field._isDependent">
                <v-select
                  v-model="field.parentField"
                  :items="listParentCandidates(field)"
                  item-text="name"
                  item-value="_id"
                  label="Campo padre"
                  class="mt-3"
                  filled
                  rounded
                  clearable
                  :disabled="!field.edit && !field.new"
                  @change="onParentFieldChange(field)"
                />
                <template v-if="field.parentField">
                  <p class="font-weight-bold mt-2 mb-1">Opciones por respuesta del campo padre</p>
                  <p class="caption grey--text mb-2">Define las sub-opciones que aparecerán según lo que elija el usuario.</p>
                  <div
                    v-for="parentOpt in getParentFieldOptions(field)"
                    :key="parentOpt"
                  >
                    <v-combobox
                      :value="getConditionalOpts(field, parentOpt)"
                      @input="setConditionalOpts(field, parentOpt, $event)"
                      hide-selected
                      :hint="`Opciones cuando se elige «${parentOpt}»`"
                      :label="parentOpt"
                      multiple
                      persistent-hint
                      small-chips
                      filled
                      rounded
                      class="mb-2"
                      :disabled="!field.edit && !field.new"
                    >
                      <template v-slot:no-data>
                        <v-list-item>
                          <v-list-item-content>
                            <v-list-item-title>
                              Presiona <kbd>enter</kbd> para crear una nueva opción.
                            </v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                      </template>
                    </v-combobox>
                  </div>
                </template>
              </template>

              <v-combobox
                v-if="field.fieldType === 'DOC'"
                v-model="field.accept"
                :items="fileExtensions"
                item-text="text"
                item-value="value"
                hide-selected
                hint="Agrega los formatos permititdos para este campo. O agrega el que necesites ej: .pdf, .docx, .jpg"
                label="Formatos permitidos del campo"
                multiple
                persistent-hint
                small-chips
                filled
                rounded
                :disabled="!field.edit && !field.new"
              >
                <template v-slot:no-data>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title>
                        Presiona
                        <kbd>enter</kbd> para agregar el formato.
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </template>
              </v-combobox>

              <!-- Visibilidad -->
              <div
                class="d-flex align-center justify-space-between font-weight-bold mt-2 mb-0"
                style="cursor:pointer;user-select:none"
                @click="toggleVisibility(field._id)"
              >
                <span>¿Quién puede ver este campo?</span>
                <v-icon small :style="{ transition: 'transform .25s ease', transform: visibilityOpen[field._id] === true ? 'rotate(0deg)' : 'rotate(-90deg)' }">mdi-chevron-down</v-icon>
              </div>
              <v-expand-transition>
                <div v-show="visibilityOpen[field._id] === true">
                  <p class="caption grey--text mb-1 mt-1">Define a quién se le mostrará este campo en el formulario.</p>
                  <div class="d-flex flex-wrap mt-2" style="gap:8px">
                    <v-tooltip top color="primary" max-width="220">
                      <template v-slot:activator="{ on, attrs }">
                        <span v-bind="attrs" v-on="on">
                          <v-chip
                            small filter
                            input-value="true"
                            disabled
                            color="grey lighten-1"
                          >Administrador Principal</v-chip>
                        </span>
                      </template>
                      <span style="font-size:12px">El administrador principal puede ver todos los campos.</span>
                    </v-tooltip>
                    <v-chip
                      v-if="hasChapters"
                      small
                      :outlined="!(field.visibleFor && field.visibleFor.includes('BRANCH')) && (field.edit || field.new)"
                      :disabled="!field.edit && !field.new"
                      :color="(!field.edit && !field.new) ? 'grey lighten-1' : 'primary'"
                      @click="toggleVisibleFor(field, 'BRANCH')"
                    ><v-icon small left :color="(field.visibleFor && field.visibleFor.includes('BRANCH')) ? 'white' : 'grey'">mdi-check</v-icon>Administradores de Capítulos Locales</v-chip>
                    <v-chip
                      small
                      :outlined="!(field.visibleFor && field.visibleFor.includes('MEMBER')) && (field.edit || field.new)"
                      :disabled="!field.edit && !field.new"
                      :color="(!field.edit && !field.new) ? 'grey lighten-1' : 'primary'"
                      @click="toggleVisibleFor(field, 'MEMBER')"
                    ><v-icon small left :color="(field.visibleFor && field.visibleFor.includes('MEMBER')) ? 'white' : 'grey'">mdi-check</v-icon>Miembro Titular</v-chip>
                    <v-chip
                      v-if="allowSubmembers"
                      small
                      :outlined="!(field.visibleFor && field.visibleFor.includes('MEMBERSHIP_USER')) && (field.edit || field.new)"
                      :disabled="!field.edit && !field.new"
                      :color="(!field.edit && !field.new) ? 'grey lighten-1' : 'primary'"
                      @click="toggleVisibleFor(field, 'MEMBERSHIP_USER')"
                    ><v-icon small left :color="(field.visibleFor && field.visibleFor.includes('MEMBERSHIP_USER')) ? 'white' : 'grey'">mdi-check</v-icon>Submiembros (Colaboradores)</v-chip>
                  </div>
                </div>
              </v-expand-transition>

              <div
                class="d-flex align-center justify-space-between font-weight-bold mt-4 mb-0"
                style="cursor:pointer;user-select:none"
                @click="togglePermissions(field._id)"
              >
                <span>¿Quién puede editar este campo?</span>
                <v-icon small :style="{ transition: 'transform .25s ease', transform: permissionsOpen[field._id] === true ? 'rotate(0deg)' : 'rotate(-90deg)' }">mdi-chevron-down</v-icon>
              </div>
              <v-expand-transition>
                <div v-show="permissionsOpen[field._id] === true">
                  <div class="d-flex flex-wrap mt-2" style="gap:8px">
                    <v-tooltip top color="primary" max-width="220">
                      <template v-slot:activator="{ on, attrs }">
                        <span v-bind="attrs" v-on="on">
                          <v-chip
                            small filter
                            input-value="true"
                            disabled
                            color="grey lighten-1"
                          >Administrador Principal</v-chip>
                        </span>
                      </template>
                      <span style="font-size:12px">El administrador principal puede editar todos los campos.</span>
                    </v-tooltip>
                    <v-tooltip v-if="hasChapters" top color="primary" max-width="260" :disabled="!!(field.visibleFor && field.visibleFor.includes('BRANCH')) || (!field.edit && !field.new)">
                      <template v-slot:activator="{ on, attrs }">
                        <span v-bind="attrs" v-on="on">
                          <v-chip
                            small
                            :outlined="!(field.permissions && field.permissions.includes('BRANCH')) && !!(field.edit || field.new) && !!(field.visibleFor && field.visibleFor.includes('BRANCH'))"
                            :disabled="(!field.edit && !field.new) || !(field.visibleFor && field.visibleFor.includes('BRANCH'))"
                            :color="((!field.edit && !field.new) || !(field.visibleFor && field.visibleFor.includes('BRANCH'))) ? 'grey lighten-1' : 'primary'"
                            @click="togglePermission(field, 'BRANCH')"
                          ><v-icon small left :color="(field.permissions && field.permissions.includes('BRANCH')) ? 'white' : 'grey'">mdi-check</v-icon>Administradores de Capítulos Locales</v-chip>
                        </span>
                      </template>
                      <span style="font-size:12px">Para permitirle editar el campo, primero debes permitir que lo pueda ver.</span>
                    </v-tooltip>
                    <v-tooltip top color="primary" max-width="260" :disabled="!!(field.visibleFor && field.visibleFor.includes('MEMBER')) || (!field.edit && !field.new)">
                      <template v-slot:activator="{ on, attrs }">
                        <span v-bind="attrs" v-on="on">
                          <v-chip
                            small
                            :outlined="!(field.permissions && field.permissions.includes('MEMBER')) && !!(field.edit || field.new) && !!(field.visibleFor && field.visibleFor.includes('MEMBER'))"
                            :disabled="(!field.edit && !field.new) || !(field.visibleFor && field.visibleFor.includes('MEMBER'))"
                            :color="((!field.edit && !field.new) || !(field.visibleFor && field.visibleFor.includes('MEMBER'))) ? 'grey lighten-1' : 'primary'"
                            @click="togglePermission(field, 'MEMBER')"
                          ><v-icon small left :color="(field.permissions && field.permissions.includes('MEMBER')) ? 'white' : 'grey'">mdi-check</v-icon>Miembro Titular</v-chip>
                        </span>
                      </template>
                      <span style="font-size:12px">Para permitirle editar el campo, primero debes permitir que lo pueda ver.</span>
                    </v-tooltip>
                    <v-tooltip v-if="allowSubmembers" top color="primary" max-width="260" :disabled="!!(field.visibleFor && field.visibleFor.includes('MEMBERSHIP_USER')) || (!field.edit && !field.new)">
                      <template v-slot:activator="{ on, attrs }">
                        <span v-bind="attrs" v-on="on">
                          <v-chip
                            small
                            :outlined="!(field.permissions && field.permissions.includes('MEMBERSHIP_USER')) && !!(field.edit || field.new) && !!(field.visibleFor && field.visibleFor.includes('MEMBERSHIP_USER'))"
                            :disabled="(!field.edit && !field.new) || !(field.visibleFor && field.visibleFor.includes('MEMBERSHIP_USER'))"
                            :color="((!field.edit && !field.new) || !(field.visibleFor && field.visibleFor.includes('MEMBERSHIP_USER'))) ? 'grey lighten-1' : 'primary'"
                            @click="togglePermission(field, 'MEMBERSHIP_USER')"
                          ><v-icon small left :color="(field.permissions && field.permissions.includes('MEMBERSHIP_USER')) ? 'white' : 'grey'">mdi-check</v-icon>Submiembros (Colaboradores)</v-chip>
                        </span>
                      </template>
                      <span style="font-size:12px">Para permitirle editar el campo, primero debes permitir que lo pueda ver.</span>
                    </v-tooltip>
                  </div>
                </div>
              </v-expand-transition>
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="12" sm="6" md="4">
              <p class="font-weight-bold">Vista previa</p>
              <template v-if="field.fieldType === 'LIST' && field._isDependent && field.parentField">
                <v-chip small color="blue lighten-4" class="mb-3">
                  <v-icon small left>mdi-link-variant</v-icon>
                  Depende de: {{ getParentField(field) ? getParentField(field).name : 'campo padre' }}
                </v-chip>
                <v-select
                  v-model="field._previewParentOpt"
                  :items="getParentFieldOptions(field)"
                  label="Simular selección del campo padre"
                  filled
                  rounded
                  clearable
                  dense
                  class="mb-2"
                  hide-details
                />
                <v-select
                  :items="getConditionalOpts(field, field._previewParentOpt)"
                  :label="field.name || 'Nombre del campo'"
                  :hint="field.description || ''"
                  persistent-hint
                  filled
                  rounded
                  :disabled="!field._previewParentOpt"
                />
              </template>
              <FormInput v-else :index="index" :field="field" @input="inputHandler" />
            </v-col>
            </v-row>
                  </div>
                </v-expand-transition>
              </v-card>
              </draggable>

        </v-col>
              <h3 v-else class="my-10">No se ha creado ningún campo en esta sección</h3>
            </v-row>

        </v-tab-item>
      </v-tabs-items>
    </v-col>

    <v-dialog fullscreen hide-overlay transition="dialog-bottom-transition" :value="prevDataSheet||prevCredential">
      <template v-slot:default="dialog">
        <v-btn
          v-if="$vuetify.breakpoint.smAndDown != true"
          @click="dialog.value = false, closePrev()"
          bottom
          right
          absolute
          fab
          color="accent"
          :style="{
            position: 'absolute',
            bottom: '50px',
            right: '50px',
          }"
          ><v-icon>mdi-close</v-icon></v-btn
        >
        <v-btn v-else @click="dialog.value = false, closePrev()" large bottom
          ><v-icon>mdi-close</v-icon></v-btn
        >
        <DataSheetPrev :memberData="extraFields" v-if="prevDataSheet"/>
        <CredentialPrev :memberData="extraFields" v-if="prevCredential"/>
      </template>
    </v-dialog>

    <ReservedFieldDialog
      v-model="reservedDialog"
      :reserved-name="reservedName"
      @confirm="onReservedConfirm"
      @cancel="onReservedCancel"
    />

    <SectionsTutorialDialog v-model="showTutorial" />
  </v-row>
</template>
<script>
import qs from "query-string";
import { mapMutations, mapActions, mapState } from "vuex";
import FormInput from "@/components/shared/FormInput.vue";
import ActionButton from "@/components/shared/ActionButton.vue";
import ModalTemplate from "@/components/shared/ModalTemplate";
import IconActionButton from "@/components/shared/IconActionButton.vue";
import FixedFieldsNotice from "@/components/shared/FixedFieldsNotice.vue";
import ReservedFieldDialog from "@/components/shared/ReservedFieldDialog.vue";
import Endpoints from "@/share/Endpoints";
import { formatExtraFields, groupFieldsBySection } from "@/utils";
import { findReservedTerm } from "@/utils/reservedFields";
import Vue from "vue";
import DataSheetPrev from "../../components/dashboard/previsualization/DataSheetPrev.vue";
import CredentialPrev from '../../components/dashboard/previsualization/CredentialPrev.vue';
import SectionsTutorialDialog from "@/components/shared/SectionsTutorialDialog.vue";
import draggable from "vuedraggable";

export default {
  components: {
    ActionButton,
    IconActionButton,
    ModalTemplate,
    FormInput,
    FixedFieldsNotice,
    ReservedFieldDialog,
    DataSheetPrev,
    CredentialPrev,
    SectionsTutorialDialog,
    draggable,
  },
  props: ["affiliationId"],
  data: () => ({
    isFieldValid: true,
    prevDataSheet: false,
    prevCredential: false,
    reservedDialog: false,
    reservedName: null,
    pendingField: null,
    showTutorial: false,
    showAdvancedFilters: false,
    visibilityFilter: 'ALL',
    formSections: [],
    newSectionName: '',
    savingSectionId: null,
    activeTab: 0,
    openFieldId: null,
    visibilityOpen: {},
    permissionsOpen: {},
    affiliationLevel: {
      items: [],
      selected: null,
    },
    showFloatingAdd: false,
    extraFields: [],
    fileExtensions: [
      {
        text: "PDF",
        value: ".pdf",
      },
      {
        text: "Word",
        value: ".docx",
      },
      {
        text: "Imagen",
        value: ".jpg, .jpeg, .png, .gif, .bmp, .svg",
      },
      {
        text: "Excel",
        value: ".xlsx",
      },
      {
        text: "Power Point",
        value: ".pptx",
      },
    ],
  }),
  async created() {
    if (!localStorage.getItem('sections_tutorial_seen')) {
      this.showTutorial = true;
    }
    const sectionsRes = await this.getFormSectionsByOrg(this.user._id);
    if (sectionsRes.status) {
      this.formSections = sectionsRes.data.sections || [];
    }
    const response = await this.getRegistrationFields(this.user._id);
    if (response.status) {
      this.extraFields = response.data.data;
    }

    const fieldsWithOrder = this.extraFields.filter(field => field.order != null);
    const fieldsWithoutOrder = this.extraFields.filter(field => field.order == null);

    fieldsWithOrder.sort((a, b) => a.order - b.order);

    let orderedFields = [...fieldsWithoutOrder];

    for (const field of fieldsWithOrder) {
      const position = field.order - 1; 
      orderedFields.splice(position, 0, field);
    }

    this.extraFields = orderedFields.map((f) => ({
      ...f,
      _isDependent: !!(f.parentField),
      allowMultiple: f.allowMultiple || false,
      visibleFor: (f.visibleFor && f.visibleFor.length > 0) ? f.visibleFor : ["MEMBER", "MEMBERSHIP_USER"],
    }));

  },
  watch: {
    showTutorial(val) {
      if (!val) localStorage.setItem('sections_tutorial_seen', 'true');
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  computed: {
    ...mapState("user", ["user"]),
    tabList() {
      return [{ _id: null, name: 'Sin sección' }, ...this.formSections];
    },
    hasChapters() {
      return this.user?.hierarchyType === 'TWO_LEVELS';
    },
    allowSubmembers() {
      const owner = this.user?.headOffice && typeof this.user.headOffice === 'object'
        ? this.user.headOffice
        : this.user;
      return owner ? owner.allowSubmembers !== false : true;
    },
  },
  methods: {
    toggleVisibility (fieldId) {
      this.$set(this.visibilityOpen, fieldId, this.visibilityOpen[fieldId] !== true);
    },
    togglePermissions (fieldId) {
      this.$set(this.permissionsOpen, fieldId, this.permissionsOpen[fieldId] !== true);
    },
    toggleVisibleFor (field, value) {
      const arr = field.visibleFor ? [...field.visibleFor] : [];
      const idx = arr.indexOf(value);
      if (idx === -1) {
        arr.push(value);
      } else {
        arr.splice(idx, 1);
        // Al quitar visibilidad, también quitar el permiso de edición
        const perms = field.permissions ? [...field.permissions] : [];
        const permIdx = perms.indexOf(value);
        if (permIdx !== -1) perms.splice(permIdx, 1);
        this.$set(field, 'permissions', perms);
      }
      this.$set(field, 'visibleFor', arr);
    },
    togglePermission (field, value) {
      const arr = field.permissions ? [...field.permissions] : [];
      const idx = arr.indexOf(value);
      if (idx === -1) arr.push(value); else arr.splice(idx, 1);
      this.$set(field, 'permissions', arr);
    },
    ...mapMutations("notification", ["show"]),
    ...mapActions("registrationFields", [
      "getRegistrationFields",
      "addRegistrationField",
      "updateRegistrationField",
      "deleteRegistrationField",
    ]),
    ...mapActions("formSections", [
      "getFormSectionsByOrg",
      "addFormSection",
      "updateFormSection",
      "deleteFormSection",
    ]),
    minValueRule(value) {
    const isValid = value >= 1;
    return isValid || 'El valor mínimo es 1';
  },
    handleScroll() {
      this.showFloatingAdd = window.scrollY > 200;
    },
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },
    fieldsForTab(sectionId) {
      let fields;
      if (!sectionId) {
        const sectionIds = new Set(this.formSections.map(s => s._id));
        fields = this.extraFields.filter(f => {
          const sid = f.section && (f.section._id || f.section);
          return !sid || !sectionIds.has(sid);
        });
      } else {
        fields = this.extraFields.filter(f => {
          if (!f.section) return false;
          const sid = f.section._id || f.section;
          return sid === sectionId;
        });
      }
      if (this.visibilityFilter && this.visibilityFilter !== 'ALL') {
        fields = fields.filter(f => f.visibleFor && f.visibleFor.includes(this.visibilityFilter));
      }
      return fields;
    },
    closePrev() {
      this.prevDataSheet = false;
      this.prevCredential = false;
    },
    inputHandler({ index, value }) {
      console.log(index, value);
    },
    formatAccept(accept) {
      if (!accept) return "";
      let acceptString = "";
      accept.forEach((item) => {
        acceptString += item.value + ", ";
      });
      return acceptString;
    },
    async createField(field) {
      delete field.new;
      const { _id: temporaryId, ...restFieldProps } = field;
      const payload = {
        ...restFieldProps,
        formattedName: formatExtraFields(field.name),
      };
      const response = await this.addRegistrationField(payload);
      if (response.status) {
        const { registrationField } = response.data;
        this.extraFields = this.extraFields.map((ticket) =>
          ticket._id === temporaryId
            ? {
                ...restFieldProps,
                ...registrationField,
                edit: false,
                id: registrationField._id,
              }
            : ticket
        );
        this.show({
          color: "primary",
          text: "Campo creado",
        });
      } else {
        this.show({
          color: "error",
          text: "Error al crear el campo",
        });
      }
    },
    async updateField(field) {
      const { _id: id, ...restFieldProps } = field;
      const payload = {
        ...restFieldProps,
        formattedName: formatExtraFields(field.name),
      };

      const res = await this.updateRegistrationField({ id, payload });
      if (res.status) {
        for (let i = 0; i < this.extraFields.length; i++) {
          if (this.extraFields[i]._id === field._id) {
            Vue.set(this.extraFields, i, {
              ...field,
              edit: false,
            });
          }
        }
        this.show({
          color: "primary",
          text: "Campo actualizado",
        });
      } else {
        this.show({
          color: "error",
          text: "Error al actualizar el campo",
        });
      }
    },
    saveField(field) {
      const match = findReservedTerm(field.name);
      if (match) {
        this.reservedName = match;
        this.pendingField = field;
        this.reservedDialog = true;
        return;
      }
      this.executeSave(field);
    },
    executeSave(field) {
      field?.edit && this.updateField(field);
      field?.new && this.createField(field);
    },
    onReservedConfirm() {
      const field = this.pendingField;
      this.reservedDialog = false;
      this.reservedName = null;
      this.pendingField = null;
      if (field) this.executeSave(field);
    },
    onReservedCancel() {
      this.reservedDialog = false;
      this.reservedName = null;
      this.pendingField = null;
    },
    editField(field) {
      Vue.set(field, "edit", true);
      field.originalData = { ...field };
      this.openFieldId = field._id;
      console.log(field);
    },
    cancelEdition(field) {
      this.extraFields = this.extraFields.map((auxField) =>
        auxField._id === field._id
          ? { ...field.originalData, edit: false }
          : { ...auxField }
      );
    },
    cancelAction(field) {
      if (this.openFieldId === field._id) this.openFieldId = null;
      field?.edit && this.cancelEdition(field);
      field?.new && this.removeField(field._id);
    },
    toggleField(field) {
      this.openFieldId = this.openFieldId === field._id ? null : field._id;
    },
    isFieldOpen(field) {
      return this.openFieldId === field._id || !!field.new || !!field.edit;
    },
    fieldTypeLabel(type) {
      const map = { TEXT: 'Texto', LIST: 'Opción múltiple', DOC: 'Documento', DATE: 'Fecha', NUMBER: 'Número', IMAGE: 'Imagen' };
      return map[type] || type;
    },
    persistFieldOrder(field) {
      if (!field._id || field.new) return;
      this.axios.put(
        Endpoints.extraFieldsModifyField.replace(':fieldId', field._id),
        { registrationField: { order: field.order } }
      ).catch(() => {});
    },
    onFieldDragEnd({ oldIndex, newIndex }, tabId) {
      if (oldIndex === newIndex) return;
      const tabFields = this.fieldsForTab(tabId).slice();
      const [moved] = tabFields.splice(oldIndex, 1);
      tabFields.splice(newIndex, 0, moved);
      tabFields.forEach((f, i) => { f.order = i + 1; });
      const others = this.extraFields.filter(f => {
        const sid = (f.section && (f.section._id || f.section)) || null;
        return sid !== (tabId || null);
      });
      this.extraFields = [...others, ...tabFields];
      tabFields.filter(f => !f.new).forEach(f => this.persistFieldOrder(f));
    },
    addField() {
      const activeSection = this.tabList[this.activeTab];
      const field = {
        _id: new Date().getTime(),
        organization: this.user._id,
        fieldType: "TEXT",
        required: false,
        showInCredential: false,
        showInDataSheet: false,
        name: "",
        formattedName: "",
        description: "",
        options: [],
        accept: [],
        value: "",
        parentField: null,
        conditionalOptions: null,
        allowMultiple: false,
        _isDependent: false,
        new: true,
        section: activeSection?._id || null,
        permissions: [],
        visibleFor: [],
      };
      this.extraFields.push({ ...field, deleteDialog: false });
      this.openFieldId = field._id;
      this.$nextTick(() => {
        window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
      });
    },
    async deleteField(field) {
      const { _id: fieldId, new: newField } = field;
      if (!newField) {
        await this.axios.delete(
          Endpoints.extraFieldsModifyField.replace(":fieldId", fieldId)
        );
        this.show({
          color: "primary",
          text: "Campo eliminado correctamente",
        });
      }
      this.removeField(fieldId);
      field.deleteDialog = false;
    },
    removeField(fieldId) {
      this.extraFields = this.extraFields.filter(
        (field) => field._id !== fieldId
      );
    },
    disableField(field) {
      const { originalData, ...rest } = field;
      const isFormWithoutChanges =
        JSON.stringify(originalData) === JSON.stringify(rest);
      return isFormWithoutChanges;
    },
    onToggleDependent(field) {
      if (!field._isDependent) {
        field.parentField = null;
        field.conditionalOptions = null;
      }
    },
    listParentCandidates(field) {
      return this.extraFields.filter(
        (f) => f.fieldType === 'LIST' && f._id !== field._id
      );
    },
    getParentField(field) {
      if (!field.parentField) return null;
      return this.extraFields.find((f) => f._id == field.parentField) || null;
    },
    getParentFieldOptions(field) {
      const parent = this.getParentField(field);
      if (!parent) return [];
      // If parent is itself dependent, derive its possible options from all its conditionalOptions values
      if (parent._isDependent && parent.conditionalOptions) {
        const allOpts = new Set();
        const co =
          parent.conditionalOptions instanceof Map
            ? Object.fromEntries(parent.conditionalOptions)
            : parent.conditionalOptions;
        Object.values(co).forEach((opts) => opts.forEach((o) => allOpts.add(o)));
        return [...allOpts];
      }
      return parent.options || [];
    },
    getConditionalOpts(field, optKey) {
      if (!field.conditionalOptions || !optKey) return [];
      const co =
        field.conditionalOptions instanceof Map
          ? Object.fromEntries(field.conditionalOptions)
          : field.conditionalOptions;
      return co[optKey] || [];
    },
    setConditionalOpts(field, optKey, values) {
      if (!field.conditionalOptions) {
        Vue.set(field, 'conditionalOptions', {});
      }
      Vue.set(field.conditionalOptions, optKey, values);
    },
    onParentFieldChange(field) {
      field.conditionalOptions = null;
    },
    async addSection() {
      const nextOrder = this.formSections.length + 1;
      const res = await this.addFormSection({
        name: 'Nueva sección',
        order: nextOrder,
        organization: this.user._id
      });
      if (res.status) {
        this.formSections.push({ ...res.data.section, _editing: true });
        this.$nextTick(() => {
          this.activeTab = this.formSections.length; // tabList = [Sin sección, ...sections]
        });
      }
    },
    async saveSectionName(section) {
      this.savingSectionId = section._id;
      await this.updateFormSection({ id: section._id, payload: { name: section.name, order: section.order } });
      Vue.set(section, '_editing', false);
      this.savingSectionId = null;
    },
    async removeSectionAdmin(section) {
      const res = await this.deleteFormSection(section._id);
      if (res.status) {
        this.activeTab = 0;
        this.formSections = this.formSections.filter(s => s._id !== section._id);
        // Unlink fields that belonged to this section
        this.extraFields = this.extraFields.map(f =>
          (f.section === section._id || (f.section && f.section._id === section._id))
            ? { ...f, section: null }
            : f
        );
        this.show({ color: 'primary', text: 'Sección eliminada' });
      }
    },
    sectionName(sectionId) {
      if (!sectionId) return null;
      const s = this.formSections.find(s => s._id === (sectionId._id || sectionId));
      return s ? s.name : null;
    },
  },
};
</script>

<style scoped>
.drag-handle {
  cursor: grab;
}
.drag-handle:active {
  cursor: grabbing;
}
.drag-ghost {
  opacity: 0.45;
  background: #f5f5f5;
  border: 2px dashed #9e9e9e !important;
  border-radius: 8px;
}
::v-deep .v-chip {
  transition: background-color 0.2s ease, border-color 0.2s ease, color 0.2s ease !important;
}
</style>